export const publicPages = ['/datenschutz'];
export default publicPages;
